<template>
  <div class="base-checkbox" :class="wrapperClass">
    <input
      :id="id"
      v-bind="$attrs"
      v-model="checkValue"
      type="checkbox"
      class="visually-hidden"
      :required="required"
    >
    <label :for="id" :class="labelClass">
      <span class="checkbox">
        <check-icon size="14" stroke-width="4" />
      </span>
      <span v-if="label" class="ml-2" v-text="labelText" />
    </label>
  </div>
</template>

<script>
import {
  CheckIcon
} from '@bit/vekenkaluste.veke-ui.icons'

export default {
  name: 'BaseCheckbox',
  components: { CheckIcon },
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Boolean, String, Array],
      default: false
    },
    wrapperClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    },
    labelClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    id () {
      return this.$attrs.id || this.name
    },
    labelText () {
      return this.label + (this.required ? ' *' : '')
    },
    checkValue: {
      get () { return this.modelValue },
      set (val) { this.$emit('update:modelValue', val) }
    }
  }
}
</script>

<style lang="scss">
.base-checkbox {
  @apply h-6;

  input {
    &:disabled + label {
      filter: saturate(0) brightness(0.95);
    }
    &:checked + label > .checkbox {
      @apply bg-black border-black;
      > svg {
        stroke-dashoffset: 60;
      }
    }
    &:focus-visible + label > .checkbox {
      @apply shadow-md border-black;
    }
  }

  label {
    @apply inline-flex items-center cursor-pointer font-display antialiased leading-none tracking-wide select-none text-14;
    .checkbox {
      @apply inline-grid place-content-center self-start p-1 w-6 h-6 border rounded bg-white text-white overflow-hidden;
      > svg {
        transition: all 300ms;
        stroke-dasharray: 30;
        stroke-dashoffset: 30;
      }
    }
  }
}
</style>
